import { createApi } from '@reduxjs/toolkit/query/react'
import { CREATE_SCHOOL, LIST_SCHOOL, REMOVE_SCHOOL, UPDATE_SCHOOL, VIEW_SCHOOL } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const schoolsApi = createApi({
  reducerPath: 'schoolsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: "/school",
  }),
  tagTypes: ["Schools"],
  endpoints: (builder) => ({
    // get Schools list
    getSchoolList: builder.query({
      query: ({ search = "", status = "", page = 1, limit = 10, division = [], sort = { column: "name", direction: "ASC" } }) => { 
        return ({
          method: "PATCH",
          url: LIST_SCHOOL,
          data: {
            search,
            status,
            page,
            limit,
            division: division,
            sort,
          },
        })},
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["Schools"]
    }),

    // get School profile
    getSchoolData: builder.query({
      query: (id) => ({
        method: "GET",
        url: `${VIEW_SCHOOL}/${id}`
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["Schools"]
    }),

    // create School profile
    createSchool: builder.mutation({
      query: (data) => ({
        method: "POST",
        url: CREATE_SCHOOL,
        data
      }),
      invalidatesTags: ["Schools"]
    }),

    // update School profile
    updateSchool: builder.mutation({
      query: (data) => ({
        method: "PUT",
        url: `${UPDATE_SCHOOL}/${data.id}`,
        data: data.payload
      }),
      invalidatesTags: ["Schools"]
    }),

    // delete School profile
    deleteSchool: builder.mutation({
      query: (id) => ({
        method: "DELETE",
        url: `${REMOVE_SCHOOL}/${id}`
      }),
      invalidatesTags: ["Schools"]
    }),
  }),
})

export const {
  useGetSchoolListQuery,
  useCreateSchoolMutation,
  useGetSchoolDataQuery,
  useUpdateSchoolMutation,
  useDeleteSchoolMutation,
  useLazyGetSchoolListQuery,
} = schoolsApi;